import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ImportError } from '../../../models';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import {MenuImportDto} from "../../../models/menu.import.dto";

@Injectable({
  providedIn: 'root',
})
export class ImportErrorHttpService {
  private http = inject(HttpClient);

  /**
   * Returns all Import Errors from the Dish API, filtered by ClientId and optionally LocationId
   * @param clientId an optional client ID to filter by
   * @param locationId an optional location ID to filter by
   * @param mealId an optional meal ID to filter by
   * @param date an optional meal date to filter by
   * @param page what page the paginated list is on
   * @param pageSize how many records to show on the page
   */
  getBy(
    clientId?: number,
    locationId?: number,
    mealId?: number,
    date?: Date,
    code?: string,
    page?: number,
    pageSize?: number,
  ): Observable<ImportError[]> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    let params = new HttpParams();
    if(clientId){
      params = params.append('clientId', clientId);
    }
    if(locationId){
      params = params.append('locationId', locationId);
    }
    if(mealId) {
      params = params.append('mealId', mealId);
    }
    if(date) {
      params = params.append('date', date.toISOString());
    }
    if(code) {
      params = params.append('code', code);
    }
    if(page) {
      params = params.append('page', page);
    }
    if(pageSize) {
      params = params.append('pageSize', pageSize);
    }
    const endpoint = 'import-error-logs';

    return this.http.get<ImportError[]>(`${environment.apiUrl}/${endpoint}`, {
      headers: headers,
      params: params,
    });
  }

  importMissingRecipes(clientId: number, recipeIds: number[]) {
    return this.http.post<void>(`${environment.apiUrl}/client-products/import`, {
      clientId,
      recipeIds
    });
  }

  importMissingMenu(menu: MenuImportDto) {
    return this.http.post<void>(`${environment.apiUrl}/manual-menu-import`,
      menu
    )
  }
}
